import { ValidationService } from './validation-service';
import * as $ from 'jquery';
import { removeListener } from 'cluster';


interface ValidationRule {
    required?: boolean,
    minlength?: number,
    maxlength?: number,
    min?: number,
    max?: number,
    email?: boolean,
    range?: Array<Number>,
    validateMask?: boolean,
    validateFiles?: boolean,
    validateRequiredOne?: string,
    validateMinFileCount?: number,
    MinFileCountHack?:{selector:string,count:number}
}

export default function setupValidation(formSelector: string) {
    try {
        let rules = {};
        let errorMessages = {};
        let currentForm = $(formSelector);

        currentForm.find("input, select, textarea").each(function (i, inp) {

            let type = inp.getAttribute("type");
            let rule: ValidationRule = {};
            if (inp.hasAttribute('required')) {
                rule.required = true;
            }
            if (inp.hasAttribute('data-pb-inputmask')) {
                rule.validateMask = true;
            }
            if (inp.hasAttribute('data-required-one-element')) {
                rule.validateRequiredOne = inp.getAttribute('data-required-one-element');
            }
            if (type == 'file'){
                rule.validateFiles = true;
            }
            if(type == 'file' && inp.hasAttribute('data-required-min-count')){
                rule.validateMinFileCount = +inp.getAttribute('data-required-min-count')
            }
            if(inp.hasAttribute('data-required-min-counthack')){
                rule.MinFileCountHack = {
                    count: +inp.getAttribute('data-required-min-counthack'),
                    selector: inp.getAttribute('data-required-min-targethack')
                }
            }
            if (inp.hasAttribute('maxlength')) {
                rule.maxlength = +inp.getAttribute('maxlength');
            }
            if (inp.hasAttribute('data-required-minlength')) {
                rule.minlength = +inp.getAttribute('data-required-minlength');
            }
            if (inp.hasAttribute('max') && inp.hasAttribute('min')) {
                rule.range = [+inp.getAttribute('min'), +inp.getAttribute('max')];
            }
            else {
                if (inp.hasAttribute('min')) {
                    rule.min = +inp.getAttribute('min');
                }
                if (inp.hasAttribute('max')) {
                    rule.max = +inp.getAttribute('max');
                }
            }
            if (inp.getAttribute('type') == 'email') {
                rule.email = true;
            }
            if (Object.keys(rule).length) {
                let ruleName =inp.getAttribute('name');
                if($(inp).closest('.repeatable-component').length>0 && inp.getAttribute('name').slice(-2)!='[]'){
                    ruleName +='[]';
                }
                rules[ruleName] = rule;

                let errors: any = { ...rule };
                for (let error in errors) {
                    errors[error] = inp.getAttribute('data-error-message');
                    if (error == 'minlength')
                        errors[error] = inp.getAttribute('data-minlength-error-message');
                    if (error == 'range' || error == 'min' || error == 'max') {
                        errors['min'] = inp.getAttribute('data-not-in-range-error-message');
                        errors['max'] = inp.getAttribute('data-not-in-range-error-message');
                        errors['range'] = inp.getAttribute('data-not-in-range-error-message');
                    }
                    if (error == 'validateMask') {
                        errors['validateMask'] = inp.getAttribute('data-mask-error-message')
                    }
                    if (error == 'validateFiles') {
                        errors['validateFiles'] = ''   //displayed in file list
                    }
                    if (error == 'validateMinFileCount') {
                        errors['validateMinFileCount'] = inp.getAttribute('data-required-min-count-error')
                    }
                    if (error == 'MinFileCountHack') {
                        errors['MinFileCountHack'] = inp.getAttribute('data-required-min-counthack-error')
                    }
                }
                errorMessages[ruleName] = errors;
            }

        });

        return ValidationService.setupValidation(formSelector, rules, errorMessages);
    }
    catch (ex) {
        console.warn(`Failed to set up ${formSelector} form - ${ex}`);
        return null;
    }
}


